import {
  RiGithubFill,
  RiYoutubeFill,
  RiLinkedinBoxFill,
  RiRedditFill,
  RiDiscordFill,
  RiGitlabFill,
  RiPaypalFill,
  RiTwitchFill,
  RiWordpressFill,
  RiXboxFill,
  RiPlaystationFill,
  RiMicrosoftFill,
} from "@remixicon/react"

const data = {
  "github": {
    platform: "GitHub",
    icon: <RiGithubFill />,
    color: "rgb(25, 25, 25)",
  },
  "gitlab": {
    platform: "GitLab",
    icon: <RiGitlabFill />,
    color: "#E2432A",
  },
  "youtube": {
    platform: "YouTube",
    icon: <RiYoutubeFill />,
    color: "rgb(239, 56, 58)",
  },
  "linkedin": {
    platform: "LinkedIn",
    icon: <RiLinkedinBoxFill />,
    color: "rgb(0, 119, 181)",
  },
  "reddit": {
    platform: "Reddit",
    icon: <RiRedditFill />,
    color: "#FF5700",
  },
  "discord": {
    platform: "Discord",
    icon: <RiDiscordFill />,
    color: "#5865F2",
  },
  "paypal": {
    platform: "Paypal",
    icon: <RiPaypalFill />,
    color: "#00457C",
  },
  "twitch": {
    platform: "Twitch",
    icon: <RiTwitchFill />,
    color: "#6441a5",
  },
  "wordpress": {
    platform: "Wordpress",
    icon: <RiWordpressFill />,
    color: "rgb(33, 117, 155)",
  },
  "xbox": {
    platform: "Xbox",
    icon: <RiXboxFill />,
    color: "#77bb44",
  },
  "playstation": {
    platform: "Playstation",
    icon: <RiPlaystationFill />,
    color: "#092f94",
  },
  "microsoft": {
    platform: "Microsoft",
    icon: <RiMicrosoftFill />,
    color: "rgb(3, 139, 204)",
  }
}

export default data